module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetMedium.db5c2be.jpg";